import instance from '@/service/instance';
import { AxiosPromise } from 'axios';
import { Schedule } from '@/helpers/types';

const resource: string = '/schedule';

export default {
  /**
   * Fetch list of schedules from the API
   * @param {string} token
   * @return {AxiosPromise<Schedule[]>>}
   * */
  list(token: string): AxiosPromise<Schedule[]> {
    return instance.get(`${resource}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  /**
   * Create schedule
   * @param {string} token
   * @param {any} payload
   * @return {AxiosPromise<Schedule>>}
   * */
  createSchedule(token: string, payload: any): AxiosPromise<Schedule> {
    return instance.post(`${resource}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  userList(token: string): AxiosPromise<any[]> {
    return instance.get('user', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  updateSchedule(token: string, id: number, payload: any) {
    return instance.patch(`${resource}/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
